import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [MatButtonModule, RouterModule],
  template: ` <router-outlet /> `,
  styles: `
    .fx {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
    }
  `,
})
export class PublicComponent {}
